import { initDoc } from './../index';
export function initShoppingCart(doc) {
    const init = Object.assign(Object.assign({}, initDoc()), { collection: 'shopping-carts', checkoutSessionId: '', items: [], deliverySlots: [], deliveryAddress: {
            addressOne: '',
            addressTwo: '',
            city: '',
            state: 'ny',
            zip: ''
        }, isGuestCart: true });
    return Object.assign(Object.assign({}, init), doc);
}
